export default __webpack_public_path__ + "static/media/Res_AWS-Identity-Access-Management_Add-on_48_Light.00cebc36.svg";